import { render, staticRenderFns } from "./Modal.vue?vue&type=template&id=e764e41a&scoped=true&lang=pug&"
import script from "./Modal.vue?vue&type=script&lang=js&"
export * from "./Modal.vue?vue&type=script&lang=js&"
import style0 from "./Modal.vue?vue&type=style&index=0&id=e764e41a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e764e41a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e764e41a')) {
      api.createRecord('e764e41a', component.options)
    } else {
      api.reload('e764e41a', component.options)
    }
    module.hot.accept("./Modal.vue?vue&type=template&id=e764e41a&scoped=true&lang=pug&", function () {
      api.rerender('e764e41a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/basic/Modal.vue"
export default component.exports